import { generatePath } from "react-router-dom";

export const linkToNewReferral = (): string => {
  return "/patient/referrals/new";
};

export const linkToReferralsRoot = ({
  patientId,
}: {
  patientId: string;
}): string => {
  return generatePath("/patient/:patientId/referrals", { patientId });
};
